import { useEffect } from "react";
import { useLang } from "@/i18n/LanguageContext";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useSeo(pageKey, vars) {
  const { t, lang } = useLang();
  useEffect(() => {
    const title = t(`seo.${pageKey}.t`, vars);
    const desc = t(`seo.${pageKey}.d`, vars);
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:locale", lang === "it" ? "it_IT" : lang === "fr" ? "fr_FR" : "en_US");
  }, [t, lang, pageKey, JSON.stringify(vars)]);
}
